import * as React from "react";
import { TextField, Button, Link } from "@mui/material";
import Grid from '@mui/material/Grid2';
import SearchResults from "../../components/MUIDataTableWrapper/MUIDataTableWrapper";

import {
  callSendGuestInvitation,
  callGetMemberGuests,
  callResendGuestInvitation,
} from "./services";

// Zustand store
import { useAppStore } from "../../stores";

import { useSnackbar } from "notistack";
import GenericSpinner from "../../components/GenericSpinner/GenericSpinner";

interface GuestInvitationProps {}

const GuestInvitation: React.FC<GuestInvitationProps> = (props) => {
  // Zustand store
  const memberGuests = useAppStore(
    (state) => state.guestInvitation?.memberGuests || []
  );
  const setMemberGuests = useAppStore((state) => state.setMemberGuests);

  const { enqueueSnackbar } = useSnackbar();

  const [emailToAdd, setEmailToAdd] = React.useState("");

  const textFieldOnChange = (e: React.FormEvent<EventTarget>) => {
    const { value } = e.target as HTMLFormElement;
    setEmailToAdd(value);
  };

  React.useEffect(() => {
    populateGuestsForUser();
  }, []);

  const addUserOnClick = (e: any) => {
    e.preventDefault();

    callSendGuestInvitation(emailToAdd)
      .then(function (response) {
        if (response.data) {
          populateGuestsForUser();
          enqueueSnackbar(emailToAdd + " has been invited.", {
            variant: "success",
          });
          setEmailToAdd("");
        }
      })
      .catch((ex) => {
        console.error(ex);
        enqueueSnackbar(ex.message, { variant: "error" });
      });
  };

  const resendGuestInvitation = (e: any, guestId: number) => {
    e.preventDefault();
    callResendGuestInvitation(guestId)
      .then(function (response: any) {
        if (response.data) {
          enqueueSnackbar("Invitation email has been re-sent", {
            variant: "success",
          });
        }
      })
      .catch((ex) => {
        console.error(ex);
        enqueueSnackbar(ex.message, { variant: "error" });
      });
  };

  const populateGuestsForUser = () => {
    callGetMemberGuests().then(function (response) {
      if (response.data) {
        setMemberGuests(response.data);
      }
    });
  };

  const conditionalRenderingGuestStatus = (
    statusCodeId: number,
    statusCodeName: string
  ) => {
    switch (statusCodeId) {
      case 1:
        return <span style={{ color: "#787E8C" }}>{statusCodeName}</span>;
      case 2:
        return <span style={{ color: "#FF7D35" }}>{statusCodeName}</span>;
      case 3:
        return <span style={{ color: "#2e992b" }}>{statusCodeName}</span>;
      default:
        return <span>statusCodeName</span>;
    }
  };

  return (
    <Grid container size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }} style={{ marginBottom: "2em" }}>
        <h2>Guest Invitation</h2>
      </Grid>

      <Grid container size={{ xs: 12 }} spacing={1}>
        <Grid size={{ xs: 12, md: 4 }}>
          <TextField
            fullWidth={true}
            variant="outlined"
            label="Add a user by their email address"
            name="emailAddress"
            value={emailToAdd}
            onChange={textFieldOnChange}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Button
            className="btn"
            size="large"
            variant="contained"
            color="primary"
            onClick={addUserOnClick}
          >
            <span style={{ padding: ".55em" }}>Add User</span>
          </Button>
        </Grid>
      </Grid>

      {/* Not currently being used. the commented out search results should be replaced with MUIDataTableWrapper component */}
      {memberGuests ? (
        <Grid container size={{ xs: 12 }} spacing={1}>
          <Grid size={{ xs: 12, md: 5 }} style={{ paddingTop: "3rem" }}>
            {/* <SearchResults
              title={"Potential Guests"}
              columns={[
                {
                  label: "Invitation Email",
                  name: "invitationEmail",
                },
                {
                  title: "Status",
                  dataIndex: "status",
                  key: "status",
                },
                {
                  title: "",
                  dataIndex: "link",
                  key: "link",
                },
              ]}
              data={memberGuests.map((memberGuest: any, index: number) => {
                let guestId = memberGuest.guestId;
                return {
                  key: guestId,
                  "guest-name": memberGuest.invitationEmail,
                  status: conditionalRenderingGuestStatus(
                    memberGuest.guestStatus.guestStatusId,
                    memberGuest.guestStatus.guestStatusType
                  ),
                  // link:
                  //   memberGuest.guestStatus.guestStatusId === 1 ? (
                  //     <Link
                  //       to="#"
                  //       onClick={(e) => resendGuestInvitation(e, guestId)}
                  //     >
                  //       Resend Email
                  //     </Link>
                  //   ) : (
                  //     ""
                  //   ),
                };
              })}
              options={{
                print: false,
                download: false,
                viewColumns: false,
                filter: false,
                rowsPerPageOptions: [5, 10, 15, 25],
                selectableRows: "none",
                responsive: "scrollMaxHeight",
              }}
            /> */}
          </Grid>
        </Grid>
      ) : (
        <GenericSpinner includeOverlay={false} padding={25} />
      )}
    </Grid>
  );
};

export default GuestInvitation;
